window.runtimeConfig = {
  AFP_URL: "https://airteam.cloud",
  AFP_SERVER_URL: "https://afp.airteam.cloud",
  FFSOLAR_SERVER_URL: "https://editor.airteam.cloud",
  STATIC_MODELS_URL:
    "https://storage.googleapis.com/airteam-rc-automation/media/files/26252/gltf_files/",
  APP_ENV: "production",
  PRODUCT_FRUITS_WORKSPACE_CODE: "xthwjpIxi5IdQzpV",
  ZITADEL_ISSUER: "https://auth.airteam.cloud",
  ZITADEL_CLIENT_ID: "327076309362608866",
};
